import * as React from "react";

function Phone(props) {
  return (
    <svg width="306" height="316" viewBox="0 0 306 316" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_505_1946)">
    <rect width="306" height="316" fill="white"/>
    <path d="M278.264 79.9236L244.825 53.228C242.464 51.3334 239.774 49.9402 236.909 49.1284C234.045 48.3167 231.061 48.1025 228.131 48.498C222.159 49.3027 216.874 52.5072 213.257 57.4812L186.164 94.7369C184.379 97.1805 183.077 99.9743 182.335 102.958C181.592 105.941 181.423 109.056 181.837 112.123C182.679 118.373 185.81 123.933 190.615 127.772L216.93 148.8C213.209 161.98 207.23 174.32 199.28 185.224C191.36 196.171 181.598 205.513 170.462 212.8L144.147 191.772C141.787 189.877 139.097 188.484 136.232 187.672C133.367 186.861 130.384 186.646 127.454 187.042C121.482 187.847 116.197 191.051 112.58 196.025L85.4553 233.256C83.6681 235.704 82.3661 238.502 81.6242 241.491C80.8823 244.48 80.7152 247.599 81.1324 250.67C81.9745 256.92 85.1055 262.48 89.91 266.32L123.291 292.994C130.957 299.145 140.771 301.899 150.294 300.616C152.303 300.346 154.206 299.913 156.058 299.312C192.296 287.919 226.311 262.311 251.824 227.262C277.313 192.246 291.835 151.112 292.781 111.339C293.049 99.1916 287.63 87.459 278.264 79.9236Z" fill="black" fill-opacity="0.85"/>
    </g>
    <defs>
    <clipPath id="clip0_505_1946">
    <rect width="306" height="316" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
  );
}

export default Phone;
